import React from 'react'
import { Box, Flex, Text } from '@workwhile/ui'
import { Link } from 'react-router-dom'
import * as ROUTES from 'constants/routes'
import { NotificationTasksHeader } from './NotificationTasksHeader'
import { NotificationTasksFilterBar } from './NotificationTasksFilterBar'
import { ColumnsFilter } from './NotificationTasksTable/ColumnsFilter/ColumnsFilter'
import { NotificationTasksTable } from './NotificationTasksTable/NotificationTasksTable'

export const NotificationTasksMain = () => {
  return (
    <>
      <NotificationTasksHeader />
      <Box margin={3}>
        <Link
          to={ROUTES.PLAYGROUND}
          style={{ textDecoration: 'none', display: 'inline-block' }}
        >
          <Text fontSize={2} color="primary" marginBottom={3}>
            ← Back to Playground
          </Text>
        </Link>
        <NotificationTasksFilterBar />
        <Flex justifyContent="flex-end" alignItems="center" mb={3} mt={2}>
          <ColumnsFilter />
        </Flex>
        <NotificationTasksTable />
      </Box>
    </>
  )
}
